import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_NOTE_LIST_ERROR,

    CLEAR_NOTE_LIST,
    CLEAR_NOTE_LIST_FILTER,
    CHANGE_NOTE_LIST_FILTER,
    CHANGE_NOTE_LIST_FILTER_FIELD,

    LOAD_NOTE_LIST_REQUEST,
    LOAD_NOTE_LIST_SUCCESS,
    LOAD_NOTE_LIST_FAILURE
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_NOTE_LIST,
    CLEAR_ERROR: CLEAR_NOTE_LIST_ERROR,
    CLEAR_FILTER: CLEAR_NOTE_LIST_FILTER,
    CHANGE_FILTER: CHANGE_NOTE_LIST_FILTER,
    CHANGE_FILTER_FIELD: CHANGE_NOTE_LIST_FILTER_FIELD,
    LOAD_REQUEST: LOAD_NOTE_LIST_REQUEST,
    LOAD_SUCCESS: LOAD_NOTE_LIST_SUCCESS,
    LOAD_FAILURE: LOAD_NOTE_LIST_FAILURE
}